export default __webpack_public_path__ + "static/media/download-app-bg.eab612fb.webp";